import React from "react";
import styled from "styled-components";
import { Button, Spinner } from "react-bootstrap";

interface CustomButtonProps extends React.ComponentPropsWithoutRef<typeof Button> {
  isSaving?: boolean;
}

const StyledButton = styled(Button)`
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 5px;
  color: #fff;
  width: 100px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &.custom-save-button {
    background-color: #5cb85c;

    &:hover {
      background-color: #43b643;
    }
  }

  &.custom-cancel-button,
  &.custom-close-button {
    background-color: #e57373;

    &:hover {
      background-color: #e45d5d;
    }
  }
`;

const CustomButton: React.FC<CustomButtonProps> = ({ isSaving = false, children, ...props }) => {
  return (
    <StyledButton disabled={isSaving} {...props}>
      <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        {isSaving && <Spinner as="span" animation="border" size="sm" />}
        {children}
      </span>
    </StyledButton>
  );
};

export default CustomButton;
